/** Human labels for HealthKit-style micronutrient keys (coach + charts). */
export const NUTRITION_MICRO_LABELS = {
  fiber: "Fiber",
  sodium: "Sodium",
  sugar: "Sugar",
  potassium: "Potassium",
  calcium: "Calcium",
  iron: "Iron",
  magnesium: "Magnesium",
  zinc: "Zinc",
  cholesterol: "Cholesterol",
  caffeine: "Caffeine",
  folate: "Folate",
  phosphorus: "Phosphorus",
  chloride: "Chloride",
  copper: "Copper",
  manganese: "Manganese",
  selenium: "Selenium",
  molybdenum: "Molybdenum",
  iodine: "Iodine",
  biotin: "Biotin",
  thiamin: "Thiamin (B1)",
  riboflavin: "Riboflavin (B2)",
  niacin: "Niacin (B3)",
  pantothenicacid: "Pantothenic acid",
  vitamina: "Vitamin A",
  vitaminb6: "Vitamin B6",
  vitaminb12: "Vitamin B12",
  vitaminc: "Vitamin C",
  vitamind: "Vitamin D",
  vitamine: "Vitamin E",
  vitamink: "Vitamin K",
  fatmonounsaturated: "Fat (monounsaturated)",
  fatpolyunsaturated: "Fat (polyunsaturated)",
  fatsaturated: "Fat (saturated)",
};

export function labelForMicroKey(key) {
  return NUTRITION_MICRO_LABELS[key] || key;
}

export function discoverMicroKeysFromNutritionSeries(series) {
  const counts = {};
  (series || []).forEach((row) => {
    const m = row.micronutrients;
    if (!m || typeof m !== "object") return;
    Object.keys(m).forEach((k) => {
      const v = m[k];
      if (typeof v === "number" && v > 0) {
        counts[k] = (counts[k] || 0) + 1;
      }
    });
  });
  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .map(([k]) => k)
    .slice(0, 12);
}
